import { SocketData } from 'actions/socket/socketReceiveDataAction'
import {
  ChatMessengerState,
  MessageIgnoredFromCometContent,
} from 'reducers/messenger/ChatMessengerState'

export const addIgnoredMessage = (
  ignoredMessage: SocketData<MessageIgnoredFromCometContent>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  const content = ignoredMessage.content

  if (
    chatState.selectedProfileId === (content.ignoredBy || content.unignoredBy)
  ) {
    return {
      ...chatState,
      forceRefetch: true,
    }
  }

  return chatState
}
